import Cookies from "cookies-js";
import { SessionStore } from "../uidispatcherapi/SessionStore";
import { CookieLaw } from "../datatypes/CookieLaw";

const tenYearsFromNow = () => new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
const sitecoreCookieName = "allowedCookieCategories";

// accepts ALL categories:
export const accept = (cookieLaw: CookieLaw) => {
    Cookies.set(
        sitecoreCookieName,
        cookieLaw.categories
            .map(item => item.id.toLowerCase())
            .join("|")
            .concat("|Uncategorized"),
        {
            expires: tenYearsFromNow(),
            domain: SessionStore.getCookieDomain()
        }
    );
};

export const isCookieExists = () => {
    let allowedCategoriesCookie = Cookies.get(sitecoreCookieName);

    if (!allowedCategoriesCookie) {
        return false;
    }

    // Sitecore safes the cookie uriEncoded, so we need to account for that
    try {
        allowedCategoriesCookie = decodeURI(allowedCategoriesCookie);
    } catch (e) {
        // do nothing
    }

    return !/default/i.test(allowedCategoriesCookie);
};

export const createDefaultCookie = (cookieLaw: CookieLaw): boolean => {
    if (!Cookies.get(sitecoreCookieName)) {
        const activeCategoriesByDefault = cookieLaw.categories
            .filter(item => item.activatedByDefault)
            .map(item => item.id.toLowerCase())
            .join("|");
        const allowedCookieCategories = "default|".concat(activeCategoriesByDefault);

        Cookies.set(sitecoreCookieName, allowedCookieCategories, {
            expires: tenYearsFromNow(),
            domain: SessionStore.getCookieDomain()
        });
        return false;
    }

    return isCookieExists();
};
